// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap_hhBzN","label":"index_label_L5Gud"};